import React, { useState } from "react";
import { Accordion } from "react-bootstrap";

const InvoiceOverlay = ({ overlay, setOverlay, invoiceDetails }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [activeCard, setActiveCard] = useState([]);
  const [cardClose, setCardClose] = useState(true);
  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };

  const [activeKeys, setActiveKeys] = useState([
    "0",
    "3",
    "6",
    "7",
    "8",
    "9",
    // "10",
    // "11",
    "17",
    "20",
  ]); // Initially open accordions

  const mainCardSwitch = (val1, val2, val3, detailObj) => {
    setActiveCard((prev) => {
      let updated = [...prev];
      updated = updated.filter(item => item !== val2 && item !== val3);
      if (!updated.includes(val1)) {
        updated.unshift(val1);
      }
      return updated;
    });
  };



  return (
    <div>
      <div className={`overlay ${overlay ? "d-none" : null}  `}></div>

      <div
        className={`overlayContent overflow-auto ${
          overlay ? "left-100" : null
        } `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center ps-4 py-3">
          <div className="fw-600 fs-16px d-flex align-items-center gap-2 ">
            <i
              className="icon-close_circle_fill fs-5 cursor-pointer"
              onClick={() => setOverlay(true)}
            ></i>
            Invoice Details
            {/* <span className="text-warning-100 fs-16px fw-500">
              Total invoice 20
            </span> */}
          </div>
        </div>

        <div className="px-4 py-3 d-flex flex-column gap-2">
          {/* ======================card view=========================== */}

          <div className="head m-0 p-0 d-flex justify-content-between align-items-center">
            {/* <span className="fw-500 fs-14px">Invoice 01</span>
            <span className="fw-500 fs-14px d-flex align-items-center gap-2">
                Showing 1/20 
                <span >
                    <i className="icon-keyboard_arrow_left fw-500 fs-16px"></i>
                    <i className="icon-keyboard_arrow_right fw-500 fs-16px"></i>
                </span>
            </span> */}
          </div>

          <div className="bg-white border-Prime-100 rounded-3 p-0 m-0 px-2 ">
            {/* ================================card body========================= */}

            {/* <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
              Invoice Details
            </div> */}

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">
                  Sanction Order No:
                </span>
                <span className="fs-14px fw-500">{invoiceDetails?.sanction_order_no}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">
                  Sanction Order Date:
                </span>
                <span className="fs-14px fw-500">{invoiceDetails?.sanction_order_date}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">
                  Sanction Order Amount:
                </span>
                <span className="fs-14px fw-500">{invoiceDetails?.sanction_amount}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <a href={invoiceDetails?.sanction_order} target="_blank" style={{color: 'black'}}><i className="icon-picture_as_pdf fs-18px text-danger-100"></i></a>
                {/* <i className="icon-picture_as_pdf fs-18px text-danger-100"></i> */}
                {/* <i className="icon-picture_as_pdf fs-18px text-danger-100"></i> */}
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Voucher No:</span>
                <span className="fs-14px fw-500">{invoiceDetails?.voucher_no}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Voucher Date:</span>
                <span className="fs-14px fw-500">{invoiceDetails?.voucher_date}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Voucher Amount:</span>
                <span className="fs-14px fw-500">{invoiceDetails?.voucher_amount}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <a href={invoiceDetails?.voucher} target="_blank" style={{color: 'black'}}><i className="icon-picture_as_pdf fs-18px text-danger-100"></i></a>
                
                {/* <i className="icon-picture_as_pdf fs-18px text-danger-100"></i> */}
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Vendor Name</span>
                <span className="fs-14px fw-500">{invoiceDetails?.beneficiary_other_details?.beneficiary_company_name}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Account No.</span>
                <span className="fs-14px fw-500">{invoiceDetails?.b_account_no}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">IFSC</span>
                <span className="fs-14px fw-500">{invoiceDetails?.b_ifsc_code}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60 d-flex justify-content-between align-items-center">Bank <i className="icon-info fs-16px"></i> </span>
                <span className="fs-14px fw-500">{invoiceDetails?.b_bank_name}</span>
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Invoice No:</span>
                <span className="fs-14px fw-500">{invoiceDetails?.invoice_no}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Invoice Date:</span>
                <span className="fs-14px fw-500">{invoiceDetails?.invoice_date}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Payment Type:</span>
                <span className="fs-14px fw-500">{invoiceDetails?.payment_type === '1' ? 'FULL PAYMENT' : 'PART PAYMENT'}</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Taxable Amount</span>
                <span className="fs-14px fw-500">{invoiceDetails?.taxable_amount}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Invoice Amount</span>
                <span className="fs-14px fw-500">{invoiceDetails?.invoice_value}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Sanctioned</span>
                <span className="fs-14px fw-500">{invoiceDetails?.sanction_amount}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Deduction</span>
                <span className="fs-14px fw-500">{invoiceDetails?.total_deduction}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">with-held</span>
                <span className="fs-14px fw-500">{invoiceDetails?.withheld_amount}</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Payment Amount</span>
                <span className="fs-14px fw-500 text-success-100">{invoiceDetails?.payable_amount}</span>
              </div>
            </div>

            {/* ================================scheme details============================ */}

            <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
              Scheme Details
            </div>

            {
                invoiceDetails?.scheme_list.map((scheme, schemeIndex) => (
                    <div key={schemeIndex} style={{borderBottom: '1px solid #ccc'}}>
                        <div className="row px-2">
                            <div className="col-9 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                <span className="fs-12px text-black-60">Scheme Name</span>
                                <span className="fs-14px fw-500">
                                {scheme.name}
                                </span>
                            </div>
                            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                <span className="fs-12px text-black-60">Scheme Code:</span>
                                <span className="fs-14px fw-500">{scheme.code}</span>
                            </div>
                            </div>
                            <div className="row px-2">
                            <div className="col-2 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                <span className="fs-12px text-black-60">Grant Code:</span>
                                <span className="fs-14px fw-500">{scheme.grant_code}</span>
                            </div>
                            <div className="col-4 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                <span className="fs-12px text-black-60">Scheme Type:</span>
                                <span className="fs-14px fw-500">
                                {scheme.type}
                                </span>
                            </div>
                            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                <span className="fs-12px text-black-60">
                                From Bal. of FY (Var):
                                </span>
                                <span className="fs-14px fw-500">{scheme.financial_year}</span>
                            </div>
                            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                <span className="fs-12px text-black-60">Total Amount:</span>
                                <span className="fs-14px fw-500">{scheme.invoice_scheme_amount}</span>
                            </div>
                            </div>

                            <div className="px-2 m-0 mt-1">
                            <div className="border mb-2 mx-2"></div>

                            {/* <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                {!(cardClose === false && activeCard == 1) ? (
                                <button
                                    onClick={() => {
                                    setActiveCard(1);
                                    setCardClose(false);
                                    }}
                                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                    activeCard == 1 ? "bg-secondary-20" : "bg-white"
                                    } `}
                                >
                                    {activeCard == 1 ? (
                                    <i className="icon-remove_circle_outline"></i>
                                    ) : (
                                    <i className="icon-add_circle_outline"></i>
                                    )}
                                    Sub head
                                </button>
                                ) : (
                                <button
                                    onClick={() => {
                                    setActiveCard(0);
                                    setCardClose(true);
                                    }}
                                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                    activeCard == 1 ? "bg-secondary-20" : "bg-white"
                                    } `}
                                >
                                    {activeCard == 1 ? (
                                    <i className="icon-remove_circle_outline"></i>
                                    ) : (
                                    <i className="icon-add_circle_outline"></i>
                                    )}
                                    Sub head
                                </button>
                                )}

                                <>
                                {!(cardClose === false && activeCard == 2) ? (
                                    <button
                                    onClick={() => {
                                        setActiveCard(2);
                                        setCardClose(false);
                                    }}
                                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                        activeCard == 2 ? "bg-secondary-20" : "bg-white"
                                    } `}
                                    >
                                    {activeCard == 2 ? (
                                        <i className="icon-remove_circle_outline"></i>
                                    ) : (
                                        <i className="icon-add_circle_outline"></i>
                                    )}
                                    Activity
                                    </button>
                                ) : (
                                    <button
                                    onClick={() => {
                                        setActiveCard(0);
                                        setCardClose(true);
                                    }}
                                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                        activeCard == 2 ? "bg-secondary-20" : "bg-white"
                                    } `}
                                    >
                                    {activeCard == 2 ? (
                                        <i className="icon-remove_circle_outline"></i>
                                    ) : (
                                        <i className="icon-add_circle_outline"></i>
                                    )}
                                    Activity
                                    </button>
                                )}

                                {!(cardClose === false && activeCard == 3) ? (
                                    <button
                                    onClick={() => {
                                        setActiveCard(3);
                                        setCardClose(false);
                                    }}
                                    className={` ${
                                        activeCard == 3 ? "bg-secondary-20" : "bg-white"
                                    } 
                                    border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                    >
                                    {activeCard == 3 ? (
                                        <i className="icon-remove_circle_outline"></i>
                                    ) : (
                                        <i className="icon-add_circle_outline"></i>
                                    )}
                                    Sub-Activity
                                    </button>
                                ) : (
                                    <button
                                    onClick={() => {
                                        setActiveCard(0);
                                        setCardClose(true);
                                    }}
                                    className={` ${
                                        activeCard == 3 ? "bg-secondary-20" : "bg-white"
                                    } 
                                    border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                    >
                                    {activeCard == 3 ? (
                                        <i className="icon-remove_circle_outline"></i>
                                    ) : (
                                        <i className="icon-add_circle_outline"></i>
                                    )}
                                    Sub-Activity
                                    </button>
                                )}
                                </>
                            </div> */}

                            <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                <button
                                onClick={() => mainCardSwitch(`subhead_${scheme?.invoice_scheme_id}`, `activity_${scheme?.invoice_scheme_id}`, `subactivity_${scheme?.invoice_scheme_id}`, {scheme_id: scheme?.invoice_scheme_id, subhead: true, activity: false, subActivity: false})}
                                className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                    activeCard.includes(`subhead_${scheme?.invoice_scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                } `}
                                >
                                {activeCard.includes(`subhead_${scheme?.invoice_scheme_id}`) ? (
                                    <i className="icon-remove_circle_outline"></i>
                                ) : (
                                    <i className="icon-add_circle_outline"></i>
                                )}
                                Sub head
                                </button>
                                {/* <button
                                onClick={() => mainCardSwitch(`activity_${scheme?.invoice_scheme_id}`,`subhead_${scheme?.invoice_scheme_id}`, `subactivity_${scheme?.invoice_scheme_id}`, {scheme_id: scheme?.invoice_scheme_id, subhead: false, activity: true, subActivity: false})}
                                className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                    activeCard.includes(`activity_${scheme?.invoice_scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                } `}
                                >
                                {activeCard.includes(`activity_${scheme?.invoice_scheme_id}`) ? (
                                    <i className="icon-remove_circle_outline"></i>
                                ) : (
                                    <i className="icon-add_circle_outline"></i>
                                )}
                                Activity
                                </button>
                                <button
                                onClick={() => mainCardSwitch(`subactivity_${scheme?.invoice_scheme_id}`,`activity_${scheme?.invoice_scheme_id}`,`subhead_${scheme?.invoice_scheme_id}`, {scheme_id: scheme?.invoice_scheme_id, subhead: false, activity: false, subActivity: true})}
                                className={` ${
                                    activeCard.includes(`subactivity_${scheme?.invoice_scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}>
                                {activeCard.includes(`subactivity_${scheme?.invoice_scheme_id}`) ? (
                                    <i className="icon-remove_circle_outline"></i>
                                ) : (
                                    <i className="icon-add_circle_outline"></i>
                                )}
                                Sub-Activity
                                </button> */}
                            </div>





                            {activeCard.includes(`subhead_${scheme?.invoice_scheme_id}`) && (
                                <>
                                <div className="border mx-2"></div>
                                <div style={{ overflowX: "auto" }} className="w-100 px-2">
                                    <table className="w-100">
                                    <thead>
                                        <tr style={{ border: "0" }} className="p-0 m-0">
                                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                            Subhead Code
                                        </th>
                                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                            Subhead Name
                                        </th>
                                        <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                            Subhead Amout
                                        </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            scheme?.subheads.map((subhead, subheadIndex) => (
                                                <tr key={subheadIndex}>
                                                    <td className="fs-14px border-0 p-1 text-start">
                                                    {subhead.code}
                                                    </td>
                                                    <td className="fs-14px border-0 p-1 text-start">
                                                    {subhead.name}
                                                    </td>
                                                    <td className="fs-14px border-0 p-1 text-start">
                                                    {subhead.subhead_amount}
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                    </table>
                                </div>
                                </>
                            )}

                            {/* {activeCard.includes(`activity_${scheme?.invoice_scheme_id}`) && (
                                <>
                                <div className="border mx-2"></div>
                                <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                                    <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                    <Accordion.Item
                                        eventKey="10"
                                        style={{ borderRadius: "0", border: "0" }}
                                    >
                                        <Accordion.Header
                                        onClick={() => toggleAccordion("10")}
                                        >
                                        <div className="w-100 d-flex justify-content-between">
                                            <span>Subhead Name</span>
                                            <span
                                            className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                            style={{
                                                height: "13.33px",
                                                width: "13.33px",
                                            }}
                                            >
                                            {activeKeys.includes("10") ? "-" : "+"}
                                            </span>
                                        </div>
                                        </Accordion.Header>

                                        <Accordion.Body>
                                        <div>
                                            {
                                            <div className="row my-1 p-0 mx-0">
                                                <div className="row p-2 text-start">
                                                <div className="col-5 d-flex flex-column">
                                                    <span className="fs-12px text-black-60">
                                                    {" "}
                                                    Activity
                                                    </span>
                                                    <span className="fs-14px fw-600">-</span>
                                                </div>

                                                <div className="col d-flex flex-column">
                                                    <span className="fs-12px text-black-60">
                                                    {" "}
                                                    Provisional
                                                    </span>
                                                    <span className="fs-14px fw-600">-</span>
                                                </div>

                                                <div className="col d-flex flex-column">
                                                    <span className="fs-12px text-black-60">
                                                    Released
                                                    </span>
                                                    <span className="fs-14px fw-600 ">-</span>
                                                </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    </Accordion>
                                </div>
                                </>
                            )} */}

                            {/* {activeCard.includes(`subactivity_${scheme?.invoice_scheme_id}`) && (
                                <>
                                <div className="border mx-2"></div>
                                <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                                    {
                                    budget.subhead_budgets.map((subhead, index) => (
                                        subhead.activities.map((activity, actIndex) => (
                                        <Accordion key={actIndex} style={{ border: "0" }}>
                                            <Accordion.Item
                                            eventKey={`subhead_subactivity_${activity.subhead_activity_id}`}
                                            style={{ borderRadius: "0", border: "0" }}
                                            >
                                            <Accordion.Header
                                                onClick={() => toggleAccordion(`subhead_subactivity_${activity.subhead_activity_id}`)}
                                            >
                                                <div className="w-100 d-flex justify-content-between">
                                                <span>{subhead.name} | {activity.activity}</span>
                                                <span
                                                    className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                    style={{
                                                    height: "13.33px",
                                                    width: "13.33px",
                                                    }}
                                                >
                                                    {activeKeys.includes(`subhead_subactivity_${activity.subhead_activity_id}`) ? "-" : "+"}
                                                </span>
                                                </div>
                                            </Accordion.Header>
            
                                            <Accordion.Body>
                                                <div style={{ overflowX: "auto" }} className="w-100 px-2">
                                                <table className="w-100">
                                                    <thead>
                                                    <tr style={{ border: "0" }} className="p-0 m-0">
                                                        <th className="fs-12px text-black-60 border-0 p-1 text-start" style={{width: "60%"}}>
                                                        Sub-Activity
                                                        </th>
                                                        <th className="fs-12px text-black-60 border-0 p-1 text-start" style={{width: "20%"}}>
                                                        Provisional
                                                        </th>
                                                        <th className="fs-12px text-black-60 border-0 p-1 text-start" style={{width: "20%"}}>
                                                        Released
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        activity.subactivities.map((subactivity, subIndex) => (
                                                        <tr key={subIndex}>
                                                            <td className="fs-14px border-0 p-1 text-start">{subactivity.subactivity}</td>
                                                            <td className="fs-14px border-0 p-1 text-start">{subactivity.provisional_budget}</td>
                                                            <td className="fs-14px border-0 p-1 text-start">{subactivity.budget}</td>
                                                        </tr>
                                                        ))
                                                    }
                                                    </tbody>
                                                </table>
                                                </div>
                                            </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                        ))
                                    ))
                                    }
                                    
                                </div>
                                </>
                            )} */}

                            </div>
                    </div>
                ))
            }


            





            <div className="row m-0 p-0 my-2">
              <div className="col-9">
                <div className="row">
                  {/* <div className="col-3">
                    <button className="d-flex align-items-center p-1 px-3 py-2 text-danger-100 fw-500 gap-1 rounded-1 w-100 justify-content-center bg-white border border-danger h-100">
                      <i className="icon-backspace"></i>
                      <span className="fs-16px">Revert</span>
                    </button>
                  </div> */}
                  <div className="col-3 m-0 p-0">
                    <div className="m-0 p-0">
                        <span className="fs-12px text-prime-100 p-0 m-0">L1 Remark</span>
                        <p style={{fontSize: '12px'}}>{invoiceDetails?.remarks}</p>
                        {/* <input type="text" placeholder="Data here" className="border-top-0 border-start-0 border-end-0 fw-500 fs-14px p-0 m-0" /> */}
                    </div>
                  </div>
                  <div className="col-3 m-0 p-0">
                    <div className="m-0 p-0">
                        <span className="fs-12px text-prime-100 p-0 m-0">L2 Remark</span>
                        <p style={{fontSize: '12px'}}>{invoiceDetails?.l2remarks}</p>
                        {/* <input type="text" placeholder="Data here" className="border-top-0 border-start-0 border-end-0 fw-500 fs-14px p-0 m-0" /> */}
                    </div>
                  </div>
                  <div className="col-3 m-0 p-0">
                    <div className="m-0 p-0">
                        <span className="fs-12px text-prime-100 p-0 m-0">L3 Remark</span>
                        <p style={{fontSize: '12px'}}>{invoiceDetails?.l3remarks}</p>
                        {/* <input type="text" placeholder="Data here" className="border-top-0 border-start-0 border-end-0 fw-500 fs-14px p-0 m-0" /> */}
                    </div>
                  </div>

                </div>
              </div>
              {/* <div className="col-3">
                <button className="d-flex align-items-center fw-500 border-0 p-1 bg-success-100 px-3 py-2 text-white gap-1 rounded-1 w-100 justify-content-center h-100">
                  <i className="icon-check_circle_outline"></i>
                  <span className="fs-16px">Proceed For Approval</span>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceOverlay;
